// Module
var code = `<ex-mono-occurrence-ecran formulaire="vm.formulaireFcn" mono-occurrence-options="vm.monoOccurrenceOptions" mono-occurrence-out="vm.monoOccurrence"> </ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;